import type { TrayState } from '../types';
import type { TileColor } from '../TileColor';
import { filterUnique } from '../../../utils/array-utils';

export function extractTrayStateColors(tray: TrayState): TileColor[] {
  const trayColors = tray.colors.flat();
  return filterUnique(trayColors).sort();
}
